module.exports = __webpack_public_path__ + "img/20200621_072117.43563469.jpg";